import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useAuthContext } from "../../hooks/useAuthContext";

const MyCourses = () => {
  const { id } = useParams();
  const { user } = useAuthContext();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [cart, setCart] = useState(() => {
    return JSON.parse(localStorage.getItem("cartItems")) || [];
  });

  const [course, setCourse] = useState({
    title: "",
    instructor: "",
    description: "",
    credit: "",
    price: "",
    category: "",
    numberOfCourses: "",
    courseRating: "",
    createdAt: "",
    lessons: [], // Initialize lessons as an empty array
  });
  const [myCourses, setMyCourses] = useState([
    {
      id: 1,
      title: "Groovy & Grails",
      description: "Course description",
      content: "Some text",
      author: "Course author",
      date: "Some text",
      time: "Some text",
      link: "Some text",
      price: "Some text",
      rating: "Some text",
    },
    {
      id: 2,
      title: "Java",
      description: "Course description",
      content: "Some text",
      author: "Course author",
      date: "Some text",
      time: "Some text",
      link: "Some text",
      price: "Some text",
      rating: "Some text",
    },
  ]);

  const AddToCart = (e, course) => {
    e.preventDefault();
    setCart([...cart, course]);
    localStorage.setItem("cartItems", JSON.stringify([...cart, course]));
  };

  return (
    <section className="my-courses">
      <div className="container">
        <div className="row">
          {myCourses.map((course) => (
            <div
              className="col-lg-4 col-md-10 col-sm-12 col-xs-12"
              key={course.id}
            >
              <div className="card">
                <video width="100%" height="200" controls className="mb-3">
                  <source src={course.content} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                <div className="card-body">
                  <h5 className="card-title">{course.title}</h5>
                  <p className="card-text">{course.description}</p>
                  <span className="placeholder col-6">{course.author}</span>
                  <span className="placeholder col-4">Some text</span>
                  <span className="placeholder col-4">Some text</span>
                </div>
              </div>
              <button
                className="btn btn-outline-warning btn-block btn-md mt-2 text-uppercase"
                onClick={(e) => AddToCart(e, course)}
              >
                Go to course
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MyCourses;
